import { useGuidesOptional } from '../GuidesProvider.jsx';
import { getEngineStrings, FALLBACK_LOCALE } from './engineStrings.js';

/**
 * The engine-string map for the guide language in force (#1938). Reads the
 * guides context without requiring it, so a component renders English when no
 * GuidesProvider is mounted (page tests, isolated design-system renders).
 */
export const useEngineStrings = () => {
  const guides = useGuidesOptional();
  return getEngineStrings(guides?.language || FALLBACK_LOCALE);
};
